import Vue from 'vue'
import VueRouter from 'vue-router'
import Router from 'vue-router'

const original = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return original.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  routes: [
    // 手术日流程
    {
      path: '/wechat/SurgicalInformation/:id',
      component: resolve => require(['@/components/wechat/SurgicalInformation'], resolve),
    },
    // 预警信息
    {
      path: '/wechat/WarningInformation/:id',
      component: resolve => require(['@/components/wechat/WarningInformation'], resolve),
    },
    // 点药提醒
    {
      path: '/wechat/MedicationReminder/:id',
      component: resolve => require(['@/components/wechat/MedicationReminder'], resolve),
    },
    // 问卷保存
    {
      path: '/wechat/InformationGathering/:id/:typeof',
      component: resolve => require(['@/components/wechat/InformationGathering'], resolve),
    },
    // 手机号绑定
    {
      path: '/wechat/PatientAddition/:id',
      component: resolve => require(['@/components/wechat/MobileBinding'], resolve),
    },
    // 患者添加
    {
      path: '/wechat/MobileBinding/:id',
      component: resolve => require(['@/components/wechat/PatientAddition'], resolve),
    },
    // 关联成功
    {
      path: '/wechat/AssociationSuccessful',
      component: resolve => require(['@/components/wechat/AssociationSuccessful'], resolve),
    },
    // 反馈成功
    {
      path: '/wechat/FeedbackSuccess',
      component: resolve => require(['@/components/wechat/FeedbackSuccess'], resolve),
    },
    // 医患聊天-患者列表
    {
      path: '/wechat/PatientChatList',
      component: resolve => require(['@/components/wechat/PatientChatList'], resolve),
    },
    // 医患聊天-对话详情
    {
      path: '/wechat/PatientChatDetail/:id',
      component: resolve => require(['@/components/wechat/PatientChatDetail'], resolve),
    },
    {
      path: '/wechat/DoctorWxBind/:id',
      component: resolve => require(['@/components/wechat/DoctorWxBind'], resolve),
    },
    // 登录页面
    {
      path: '/',
      component: resolve => require(['@/components/Login'], resolve),
    },
    // 登录后主页
    {
      path: '/home',
      name: 'home',
      component: resolve => require(['@/components/Home'], resolve),
      children: [
        // 功能设置——问卷管理 
        {
          path: '/functional/questionnaire',
          name: 'questionnaire',
          component: resolve => require(['@/components/questionnaire/homepage'], resolve),
        },
        // 功能设置——医生管理 
        {
          path: '/functional/doctorManagement',
          name: 'doctorManagement',
          component: resolve => require(['@/components/functional/doctorManagement/index'], resolve),
        },
        // 功能设置——科普管理
        {
          path: '/functional/popular',
          name: 'popular',
          component: resolve => require(['@/components/functional/popular/index'], resolve),
        },
        // 功能设置——宣教管理
        {
          path: '/functional/propaganda',
          name: 'propaganda',
          component: resolve => require(['@/components/functional/propaganda/index'], resolve),
        },
        // 功能设置——短信管理
        {
          path: '/functional/textmessage',
          name: 'textmessage',
          component: resolve => require(['@/components/functional/textmessage/index'], resolve),
        },
        // 功能设置——通知管理
        {
          path: '/functional/notice',
          name: 'notice',
          component: resolve => require(['@/components/functional/notice/index'], resolve),
        },
        // 系统管理-字典管理
        {
          path: '/system/dictionary',
          name: 'dictionary',
          component: resolve => require(['@/components/system/dictionary'], resolve),
        },
        // 系统管理-机构管理
        {
          path: '/system/institution',
          name: 'institution',
          component: resolve => require(['@/components/system/institution'], resolve),
        },
        // 系统管理-菜单管理
        {
          path: '/system/menusettings',
          name: 'menusettings',
          component: resolve => require(['@/components/system/menusettings'], resolve),
        },
        // 系统管理-角色管理
        {
          path: '/system/roleManage',
          name: 'roleManage',
          component: resolve => require(['@/components/system/roleManage'], resolve),
        },
        // 系统管理-权限管理
        {
          path: '/system/authorityManage',
          name: 'authorityManage',
          component: resolve => require(['@/components/system/authorityManage'], resolve),
        },
        // 系统管理-手术管理
        {
          path: '/system/surgicalManage',
          name: 'surgicalManage',
          component: resolve => require(['@/components/system/surgicalManage'], resolve),
        },
        // 系统管理-数据导入
        {
          path: '/system/importhomepage',
          name: 'importhomepage',
          component: resolve => require(['@/components/system/importhomepage'], resolve),
        },
        // 系统管理-版本控制
        {
          path: '/system/versionupdate',
          name: 'versionupdate',
          component: resolve => require(['@/components/system/versionupdate'], resolve),
        },
        {
          path: '/system/versionupdate',
          name: 'versionupdate',
          component: resolve => require(['@/components/system/versionupdate'], resolve),
        },
        // 账号管理-医生管理
        {
          path: '/account/doctorManagement',
          name: 'doctorManagement',
          component: resolve => require(['@/components/account/doctorManagement'], resolve),
        },
        // 账号管理-用户管理
        {
          path: '/account/userManage',
          name: 'userManage',
          component: resolve => require(['@/components/account/userManage'], resolve),
        }
      ]
    }
  ]
})